import React, { useEffect, useState } from 'react';
import { API, C } from '../constants';
import { formatDur } from '../utils';
import StarRating from './StarRating';
import useWindowSize from '../hooks/useWindowSize';

export default function DetailModal({ media, info, rating, apiJson, onPlay, onClose, onRated }) {
  const { width } = useWindowSize();
  const isMobile = width < 600;
  const [rateError, setRateError] = useState('');
  const thumb = media.thumbnail ? `${API}/thumbnail/${encodeURIComponent(media.thumbnail)}` : null;
  const handleRate = async (score) => {
    setRateError('');
    try {
      await apiJson(`${API}/api/ratings`, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ file_name: media.file, score }) });
      onRated();
    } catch {
      setRateError('No se pudo guardar tu calificación. Intenta de nuevo.');
    }
  };
  useEffect(() => {
    const esc = e => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);
  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.88)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding: isMobile ? '0' : '20px', backdropFilter:'blur(6px)' }}>
      <div onClick={e => e.stopPropagation()} style={{ background:C.bgModal, border:`1px solid ${C.accentBorder}`, borderRadius: isMobile ? '0' : '20px', width:'100%', maxWidth:'760px', maxHeight: isMobile ? '100%' : '92vh', overflow:'hidden', display:'flex', flexDirection:'column', boxShadow:'0 40px 100px rgba(0,0,0,0.8)' }}>
        <div style={{ position:'relative', flexShrink:0 }}>
          {thumb
            ? <img src={thumb} alt={media.name} style={{ width:'100%', height: isMobile ? '200px' : '300px', objectFit:'cover', display:'block' }} />
            : <div style={{ width:'100%', height: isMobile ? '180px' : '260px', background:'linear-gradient(135deg, #1c1008, #120a04)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'64px' }}>{media.type === 'movie' ? '🎬' : '📺'}</div>
          }
          <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(19,12,6,1) 0%, rgba(19,12,6,0.3) 50%, transparent 100%)', pointerEvents:'none' }} />
          <button onClick={onClose} style={{ position:'absolute', top:'14px', right:'14px', background:'rgba(0,0,0,0.6)', border:`1px solid ${C.accentBorder}`, color:C.text, width:'36px', height:'36px', borderRadius:'50%', cursor:'pointer', fontSize:'16px', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
          <div style={{ position:'absolute', bottom:'20px', left:'24px', right:'24px' }}>
            <h2 style={{ fontFamily:'Playfair Display, serif', fontSize: isMobile ? '20px' : '28px', fontWeight:'700', color:'#fff', textShadow:'0 2px 8px rgba(0,0,0,0.8)', marginBottom:'6px' }}>{info?.title || media.name}</h2>
            <div style={{ display:'flex', gap:'10px', flexWrap:'wrap', alignItems:'center' }}>
              <span style={{ background:C.accentDim, color:C.accentSoft, fontSize:'11px', padding:'3px 10px', borderRadius:'20px', border:`1px solid ${C.accentBorder}` }}>{media.type === 'movie' ? 'Película' : 'Serie'}</span>
              {info?.year > 0 && <span style={{ color:'rgba(240,230,216,0.8)', fontSize:'13px' }}>{info.year}</span>}
              {info?.genre && <span style={{ color:'rgba(240,230,216,0.8)', fontSize:'13px' }}>· {info.genre}</span>}
              {info?.duration > 0 && <span style={{ color:'rgba(240,230,216,0.8)', fontSize:'13px' }}>· {formatDur(info.duration)}</span>}
            </div>
          </div>
        </div>
        <div style={{ padding: isMobile ? '20px 16px' : '24px 32px', overflowY:'auto', flex:1 }}>
          <div style={{ display:'flex', alignItems:'center', gap:'20px', marginBottom:'20px', flexWrap:'wrap' }}>
            <div>
              <p style={{ color:C.textDim, fontSize:'11px', marginBottom:'5px', textTransform:'uppercase', letterSpacing:'1px' }}>Promedio</p>
              <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                <StarRating value={Math.round(rating?.avg || 0)} readonly size={16} />
                <span style={{ color:C.gold, fontSize:'15px', fontWeight:'700' }}>{rating?.avg ? rating.avg.toFixed(1) : '—'}</span>
                {rating?.count > 0 && <span style={{ color:C.textDim, fontSize:'12px' }}>({rating.count} votos)</span>}
              </div>
            </div>
            <div style={{ width:'1px', height:'36px', background:C.border }} />
            <div>
              <p style={{ color:C.textDim, fontSize:'11px', marginBottom:'5px', textTransform:'uppercase', letterSpacing:'1px' }}>Tu calificación</p>
              <StarRating value={rating?.mine || 0} onChange={handleRate} size={22} />
              {rateError && <p style={{ color:'#e74c3c', fontSize:'12px', marginTop:'6px' }}>{rateError}</p>}
            </div>
          </div>
          {info?.synopsis && (
            <div style={{ marginBottom:'20px' }}>
              <p style={{ color:C.textDim, fontSize:'11px', marginBottom:'8px', textTransform:'uppercase', letterSpacing:'1px' }}>Sinopsis</p>
              <p style={{ color:C.text, fontSize:'14px', lineHeight:'1.75' }}>{info.synopsis}</p>
            </div>
          )}
          {info?.director && <p style={{ color:C.textMuted, fontSize:'13px', marginBottom:'20px' }}><span style={{ color:C.textDim }}>Director: </span>{info.director}</p>}
          <button onClick={() => { onPlay(media); onClose(); }} style={{ width:'100%', padding:'16px', borderRadius:'12px', background:`linear-gradient(135deg, ${C.accent}, ${C.accentSoft})`, border:'none', color:'#fff', fontSize:'16px', fontWeight:'700', cursor:'pointer', fontFamily:'Inter, sans-serif', boxShadow:`0 8px 24px rgba(201,113,74,0.35)`, display:'flex', alignItems:'center', justifyContent:'center', gap:'10px' }}>▶ Reproducir</button>
        </div>
      </div>
    </div>
  );
}
